export function tickToTimeSec(tick: number, ppq: number, bpm: number): number {
    if (ppq <= 0) return 0;
    return (tick / ppq) * (60 / bpm);
}